import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "status-content" }
const _hoisted_3 = { class: "status-options" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { class: "status-grid" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "checkmark"
}
const _hoisted_8 = { class: "modal-actions" }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isOpen,
    onClose: $setup.close
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "modal-header" }, [
          _createElementVNode("div", { class: "modal-title" }, "Bulk Update Status")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, "Select a status to update all " + _toDisplayString($props.selectedLotsCount) + " lots", 1),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.availableStatuses, (status) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["status-option", { selected: $setup.selectedStatus === status }]),
                  key: status,
                  onClick: ($event: any) => ($setup.selectStatus(status))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["status-badge", $setup.getStatusClass(status)])
                  }, _toDisplayString($setup.displayStatus(status)), 3),
                  ($setup.selectedStatus === status)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, "✓"))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_6))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "btn cancel",
            onClick: $setup.close
          }, "Cancel"),
          _createElementVNode("button", {
            class: "btn primary v2",
            onClick: $setup.confirm,
            disabled: !$setup.selectedStatus
          }, "Update " + _toDisplayString($props.selectedLotsCount) + " lots", 9, _hoisted_9)
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}